import { createSlice } from '@reduxjs/toolkit';

export const additionalResearchSlice = createSlice({
    name: 'additionalResearch',
    initialState: {
        coverPdfPath:'',
        coverConfirmedPdfPath:'',
        pdfPath:'',
        mergePdfPath:''
    },
    reducers:{
        setAdditionalResearchCoverPdf: (state, action) => {
            state.coverPdfPath = action.payload;
        },
        setAdditionalResearchCoverConfirmedPdf: (state, action) => {
            state.coverConfirmedPdfPath = action.payload;
        },
        setAdditionalResearchPdf: (state, action) => {
            state.pdfPath = action.payload;
        },
        setAdditionalResearchMergePdf: (state, action) => {
            state.mergePdfPath = action.payload;
        }
    }
});

export const {
    setAdditionalResearchCoverPdf,
    setAdditionalResearchCoverConfirmedPdf,
    setAdditionalResearchPdf,
    setAdditionalResearchMergePdf
} = additionalResearchSlice.actions;
export default additionalResearchSlice.reducer;